export default "__VITE_ASSET__Se$fbSXL__"